

const sharableDashboardBuilderLoadingConfig = {
    name: 'mwPrInsightSharableDashboardReportBuilderLoading',
    bindings: {
        contentAvailable: '<',
        showReport: '&',
        shareReport: '&'
    },
    template: `
        <div id="sharable-dashboard__loading__outter-container" flex layout-fill layout="row" layout-align="center center">
            <div layout="column" layout-align="center center" style="width: 500px; text-align: center;">
                <img src="/img/undraw_report_mx0a.png" ng-if="$ctrl.contentAvailable !== true" />
                <img src="/img/undraw_High_five_u364.png" ng-if="$ctrl.contentAvailable === true" />
                <div class="sharable-dashboard__loading__spacer"></div>
                <div id="sharable-dashboard__loading__header" flex="100" ng-if="$ctrl.contentAvailable !== true"><span translate>Generating slides</span>...</div>
                <div id="sharable-dashboard__loading__ready-header" flex="100" layout="column" layout-align="center center" ng-if="$ctrl.contentAvailable === true" translate>The slides are ready!</div>
                <div class="sharable-dashboard__loading__spacer"></div>
                <div class="sharable-dashboard__loading__text" flex="100" translate>We are transforming your widgets into slides.  It may take a few seconds and you can edit them here when it is done</div>
                <div class="sharable-dashboard__loading__spacer"></div>
                <div id="sharable-dashboard__loading__dropplet-container" flex="100" layout="row" layout-align="center center">
                    <mw-loader flex="100" ng-if="$ctrl.contentAvailable !== true"></mw-loader>
                    <md-button class="mw-button md-primary" ng-if="$ctrl.contentAvailable === true" ng-click="$ctrl.showReport()" aria-label="{{'EDIT SLIDES' | translate}}"><span translate>EDIT SLIDES</span></md-button>
                    <md-button class="mw-button md-primary" ng-if="$ctrl.contentAvailable === true" ng-click="$ctrl.shareReport()" aria-label="{{'SHARE SLIDES' | translate}}"><span translate>SHARE SLIDES</span></md-button>
                </div>
            </div>
        </div>
    `
};

class SharableDashboardBuilderLoadingComponent {
    constructor() {
    }
    $onInit() {
    }
}

sharableDashboardBuilderLoadingConfig.controller = SharableDashboardBuilderLoadingComponent;

export {
    sharableDashboardBuilderLoadingConfig,
    SharableDashboardBuilderLoadingComponent as default
};